import { cilX } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CSidebar, CSpinner, CTabContent } from '@coreui/react-pro'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { MdDeleteForever } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AppHeader } from 'src/business/components'
import { businessApiURL, getBPDataWithoutParams, getToken } from 'src/business/services'
import { CHeading2, CHeading5 } from 'src/components/coreUIMimicComponent'
import AllGoals from './organizationComponents/AllGoals'
import { OrgainzationGoalsContainer } from './organizationComponents/styledComponents'
import { OGSeparator } from './styledComponents'
import { mediaURL } from 'src/consumer/services'

const OrganizationGoals = ({ heading }) => {
  const navigate = useNavigate()
  const [goals, setGoals] = useState([])

  // idk:
  const [selectedId, setSelectedId] = useState([])
  const [deleteOn, setDeleteOn] = useState(false)
  const [afterDelete, setAfterDelete] = useState([])
  const [desc, setDesc] = useState([])
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  async function getAndSetExisingGoals() {
    const response = await getBPDataWithoutParams('/api/secure/bc/goals')
    if (response?.status === 200) {
      setGoals(response?.data || [])
    }
  }

  async function setupPageData() {
    setLoading(true)
    await getAndSetExisingGoals()
    setLoading(false)
  }

  // idk:

  const edit = () => {
    setDeleteOn(!deleteOn)
  }

  const check = (value, id) => {
    console.log({ value, id, selectedId })
    if (value) {
      setSelectedId([...selectedId, id])
    } else {
      setSelectedId(selectedId.filter((itemId) => itemId !== id))
    }
  }

  const handleSubmit = async (e) => {
    setLoading(true)
    const form = e.currentTarget
    if (form.checkValidity() === false) {
      e.preventDefault()
      e.stopPropagation()
    }
    e.preventDefault()
    const deletedGoals = afterDelete.map((value) => value.id)
    const existingGoals = goals.map((value) => value.id)
    const body = selectedId.concat(existingGoals)
    axios
      .post(`${businessApiURL}/api/secure/bc/goals/set`, body, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        setLoading(false)
        toast.success('Goals Updated Successfully')
        navigate('/workplace')
      })
  }

  const handleRemoveItem = async (id) => {
    const goalArr = goals
    const newGoal = goalArr.filter((item) => item.id !== id)
    setAfterDelete(newGoal)
    if (window.confirm('Do you want to delete this goal?') === true) {
      const body = newGoal.map((value) => value.id)
      await axios
        .post(`${businessApiURL}/api/secure/bc/goals/set`, body, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        })
        .then((res) => {
          setLoading(false)
          toast.success('Goal Deleted Successfully!')
        })
      await getAndSetExisingGoals()
    } else {
      setAfterDelete([])
    }
  }

  const handleClick = () => {
    setVisible(!visible)
  }

  useEffect(() => {
    setupPageData()
  }, [])

  return (
    <>
      <AppHeader heading="Wellness Goals" />
      {loading ? (
        <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
      ) : (
        <>
          <CSidebar
            style={{ background: '#625B7A' }}
            size="lg"
            overlaid
            placement="end"
            visible={visible}
          >
            <CTabContent>
              <button
                onClick={() => setVisible(!visible)}
                className="btn btn-outline-danger m-4"
              >
                <CIcon icon={cilX} size="xl" />
              </button>

              <div
                className="w-100 h-80 ml-2 mt-3  d-flex flex-wrap gap-4 rounded-4 overflow-hidden  mr-3 mb-3 position-absolute top-10 end-5  "
                style={{
                  backgroundImage: `url(${mediaURL}${desc.coverIcon})`, position: 'relative', backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: '200px',
                  height: '200px',
                }}
              ><div className="w-100 h-100 position-absolute mx-auto mt-10 shadow-2xl rounded-2xl"
                style={{
                  background: 'rgba(0, 0, 0, 0.5)',
                }}>

                  <h5 className="position-relative p-4 font-black text-white">{desc.name}</h5>
                </div>
              </div>
              <p className="p-4 text-center text-lg">{desc.longDesc}</p>
            </CTabContent>
          </CSidebar>
          <OrgainzationGoalsContainer>
            <OGSeparator />
            <div>
              <CHeading2>Selected Goals</CHeading2>
              <div className="d-flex flex-row align-items-center justify-content-between">
                <button onClick={edit} className="btn btn-sm btn-ghost-danger">
                  Remove Goals
                </button>
              </div>
              <div className="py-4 mx-auto d-flex flex-wrap gap-4">
                {goals.map((item) => {
                  return (
                    <div
                      onClick={() => {
                        setDesc(item)
                      }}
                      key={item.id}
                      className=" position-relative w-72 h-48 "
                    >
                      <div
                        className="w-72 h-48 mx-auto d-flex flex-wrap gap-4 rounded-4 overflow-hidden"
                        onClick={deleteOn ? () => null : handleClick}
                        style={{
                          backgroundImage: `url(${mediaURL}${item.coverIcon})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          width: '200px',
                          height: '200px',
                          position: 'relative',
                        }}

                      >
                        {/* dark overlay */}
                        <div
                          className="position-absolute w-100 h-100 rounded-top-2xl"
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          }} />

                        {/* remove button */}
                        <button
                          onClick={() => handleRemoveItem(item.id)}
                          className={
                            deleteOn
                              ? 'btn btn-ghost-secondary position-absolute bottom-0 p-1 m-2 bg-white z-10  rounded border-none mr-3 mb-3'
                              : 'd-none'
                          }
                          style={{zIndex: 11}}
                        >
                          <i className="text-danger">
                            <MdDeleteForever />
                          </i>
                        </button>

                        {/* heading name */}
                        <CHeading5 className="position-relative p-4 font-weight-bold text-white">
                          {item.name}
                        </CHeading5>

                      </div>
                    </div>

                  )
                })}
                {/* </Slider> */}
              </div>
            </div>
            <OGSeparator />
            <CHeading2>Select more Goals</CHeading2>
            <div>
              <div>
                <div className="d-flex flex-wrap gap-4">

                  <AllGoals
                    selectedId={selectedId}
                    check={check}
                    setDesc={setDesc}
                    handleClick={handleClick}
                    token={getToken()}
                    existingGoals={goals}
                  />
                </div>
              </div>
              <div className="d-flex w-100 flex-column gap-3 flex-md-row align-items-center align-items-md-top justify-content-md-center">
                <div className="w-11/12 text-center">
                  <button
                    style={{ backgroundColor: '#624DE3', color: 'white', borderRadius: '9999px', padding: '0.5rem 1rem', width: '100%', margin: '40px', display: 'block', border: 'none', alignItems: 'center' }}
                    type="submit"
                    id="update"
                    onClick={handleSubmit}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </OrgainzationGoalsContainer>
        </>
      )}
    </>
  )
}

export default OrganizationGoals